var account_activation_email_request_client = function(
      customer_email,
      shopify_frontend_endpoint_url,
      hmac_digest,
      nonce
    ){
  var callback_url = null;// this may be set to a server for the sending of notification of emails to customers once their downloads are watermarked and ready for download.
    
  return {
    requestActivationEmail: function() {
      console.log("requestActivationEmail running");
      document.getElementById("response_message_goes_here").innerHTML = '<p style="text-align: center;"><img src="https://cdn.shopify.com/s/images/spinner_big.gif"/></p>';
      
      var customer_email = document.getElementById("customer_recovery_email").value;
      account_activation_email_client.haveActivationEmailSent(customer_email).done(account_activation_email_client.handleActivationEmailRequestResponse).fail(account_activation_email_client.log_error2);      
    },
    
  	haveActivationEmailSent: function(customer_email) {
      return $.ajax({
      type: "GET",
      url: shopify_frontend_endpoint_url,
      dataType: 'json',
        indexValue: {param1:customer_email},
      data: {functionname: 'requestAccountActivationEmail', arguments: ['',customer_email], hmacdigest: hmac_digest, nonce: nonce},
      });
    },
    
    handleActivationEmailRequestResponse: function(obj, textstatus) {
      console.log("Handling ActivationEmailRequestResponse");
      console.log(obj);
      //console.log(textstatus);
      var customer_email = this.indexValue.param1;
                                                      
      if( !('error' in obj) ) {
        var response_message = obj.result;
        console.log(response_message);                                                
        document.getElementById("customer_account_reactivation_fields").style.display = 'none';
        document.getElementById("response_message_goes_here").innerHTML = '\
      <h3 class="form__message" tabindex="-1">\
        <svg aria-hidden="true" focusable="false" viewBox="0 0 13 13">\
          <path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" fill="#428445" stroke="white" stroke-width="0.7"/>\
          <path d="M5.53271 8.66357L9.25213 4.68197" stroke="white"/>\
          <path d="M4.10645 6.7688L6.13766 8.62553" stroke="white">\
        </svg>\
'+response_message+'\
      </h3>';
      }
      else {
        var response_message = obj.error;
		console.log(response_message);
        document.getElementById("response_message_goes_here").innerHTML = '\
        <h3 class="form__message" tabindex="-1">\
          <svg aria-hidden="true" focusable="false" viewBox="0 0 13 13">\
            <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>\
            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>\
            <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>\
            <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">\
          </svg>\
'+response_message+'\
        </h3>';
      }   
    },
    
    log_error2: function(obj, textstatus) {
      console.log("ERROR in json response: ");
      console.log(obj);
      //console.log(textstatus);
      if( !('error' in obj) ) {
        var response = obj.result;
      }
      else {
        var response = obj.error;
      }
  	}
  } 
}
